'use client'

import type { NavigationHeaderProps } from '@maestro/commerce-blocks/components/navigation-header/navigation-header.types'

import NavigationHeaderFoldout from '@maestro/commerce-blocks/components/navigation-header/navigation-header-foldout'
import NavigationHeaderStandard from '@maestro/commerce-blocks/components/navigation-header/navigation-header-standard'
import { theme } from '@maestro/local/theme'

export default function NavigationHeader(props: NavigationHeaderProps) {
  const { variant } = theme().navigation

  return variant === 'foldout' ? (
    <NavigationHeaderFoldout {...props} />
  ) : (
    <NavigationHeaderStandard {...props} />
  )
}
